<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Plot Rent Adjustment History</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Adjustment History</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Plot Rent</a></li>
                    <li class="breadcrumb-item active">Adjustment History</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total</p>
                      <h4 class="mb-0">{{ summary.total || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                      <span class="avatar-title">
                        <i class="mdi mdi-format-list-bulleted font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Approved</p>
                      <h4 class="mb-0 text-success">{{ summary.approved || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success">
                      <span class="avatar-title">
                        <i class="mdi mdi-check-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Pending</p>
                      <h4 class="mb-0 text-warning">{{ summary.pending || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-warning">
                      <span class="avatar-title">
                        <i class="mdi mdi-clock-outline font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Rejected</p>
                      <h4 class="mb-0 text-danger">{{ summary.rejected || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                      <span class="avatar-title">
                        <i class="mdi mdi-close-circle font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Credits Applied</p>
                      <h4 class="mb-0 text-success">{{ numberFormat(summary.approvedCredits || 0) }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success">
                      <span class="avatar-title">
                        <i class="mdi mdi-arrow-down-bold font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Debits Applied</p>
                      <h4 class="mb-0 text-danger">{{ numberFormat(summary.approvedDebits || 0) }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                      <span class="avatar-title">
                        <i class="mdi mdi-arrow-up-bold font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title mb-0">All Adjustments</h4>
                  <div class="d-flex gap-2">
                    <button @click="exportToExcel" class="btn btn-outline-success" :disabled="adjustments.length === 0">
                      <i class="mdi mdi-microsoft-excel me-1"></i>Export
                    </button>
                    <button @click="getAdjustments" class="btn btn-outline-info">
                      <i class="mdi mdi-refresh me-1"></i>Refresh
                    </button>
                  </div>
                </div>

                <!-- Filters -->
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center g-2">
                    <div class="col-md-2">
                      <input v-model="keyword" type="text" class="form-control" placeholder="Search..." @keyup.enter="getAdjustments">
                    </div>
                    <div class="col-md-2">
                      <select v-model="selectedStatus" class="form-select">
                        <option value="">All Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Pending Level 2">Pending Level 2</option>
                        <option value="Pending Level 3">Pending Level 3</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Reverted">Reverted</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <select v-model="selectedType" class="form-select">
                        <option value="">All Types</option>
                        <option value="Credit">Credit</option>
                        <option value="Debit">Debit</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <input v-model="dateFrom" type="date" class="form-control" placeholder="From Date">
                    </div>
                    <div class="col-md-2">
                      <input v-model="dateTo" type="date" class="form-control" placeholder="To Date">
                    </div>
                    <div class="col-md-2">
                      <button @click="getAdjustments" class="btn btn-primary w-100">
                        <i class="mdi mdi-filter me-1"></i>Filter
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover">
                      <thead class="table-dark">
                        <tr>
                          <th>Reference</th>
                          <th>Date</th>
                          <th>Plot Details</th>
                          <th>Type</th>
                          <th>Category</th>
                          <th>Amount</th>
                          <th>Balance Change</th>
                          <th>Status</th>
                          <th>Requested By</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="adj in adjustments" :key="adj.id">
                          <td>
                            <strong class="text-primary">{{ adj.adjustmentRef }}</strong>
                          </td>
                          <td>
                            <small>{{ formatDate(adj.requestedDate) }}</small>
                          </td>
                          <td>
                            <div>
                              <strong>{{ adj.plotNumber }}</strong>
                              <div class="text-muted small">{{ adj.zone }}</div>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="adj.adjustmentType === 'Credit' ? 'bg-success' : 'bg-danger'">
                              <i class="mdi me-1" :class="adj.adjustmentType === 'Credit' ? 'mdi-arrow-down-bold' : 'mdi-arrow-up-bold'"></i>
                              {{ adj.adjustmentType }}
                            </span>
                          </td>
                          <td>
                            <small>{{ adj.adjustmentCategory }}</small>
                          </td>
                          <td class="text-end">
                            <strong :class="adj.adjustmentType === 'Credit' ? 'text-success' : 'text-danger'">
                              {{ adj.adjustmentType === 'Credit' ? '-' : '+' }} KES {{ numberFormat(adj.amount) }}
                            </strong>
                          </td>
                          <td class="text-center">
                            <small>
                              <span class="text-muted">{{ numberFormat(adj.balanceBefore) }}</span>
                              <i class="mdi mdi-arrow-right mx-1"></i>
                              <span :class="parseFloat(adj.balanceAfter) > 0 ? 'text-danger' : 'text-success'">{{ numberFormat(adj.balanceAfter) }}</span>
                            </small>
                          </td>
                          <td>
                            <span class="badge" :class="getStatusBadgeClass(adj.status)">
                              {{ adj.status }}
                            </span>
                            <div v-if="adj.isApplied == 1" class="small text-success mt-1">
                              <i class="mdi mdi-check-circle"></i> Applied
                            </div>
                          </td>
                          <td>
                            <small>{{ adj.requestedBy }}</small>
                          </td>
                          <td>
                            <div class="btn-group">
                              <button @click="viewDetails(adj)" class="btn btn-sm btn-outline-info" title="View Details">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <button 
                                  v-if="adj.status === 'Approved' && adj.isApplied == 1 && getRight('PLOTRENT REVERT ADJUSTMENT')" 
                                  @click="openRevertModal(adj)" 
                                  class="btn btn-sm btn-outline-warning" 
                                  title="Revert Adjustment">
                                <i class="mdi mdi-undo-variant"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="adjustments.length === 0 && !loading">
                          <td colspan="10" class="text-center py-5">
                            <i class="mdi mdi-file-document-outline text-muted" style="font-size: 48px;"></i>
                            <h5 class="mt-3">No Adjustments Found</h5>
                            <p class="text-muted">Try adjusting your filters</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Loading -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading adjustments...</p>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white">
                  <nav class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="me-2">Rows Per Page</span>
                      <select class="form-select form-select-sm w-auto" v-model="pageSize" @change="getAdjustments">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span class="ms-3 text-muted">Total: {{ totalRecords }} records</span>
                    </div>
                    <ul class="pagination mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" @click="prevPage" href="javascript:void(0)">Previous</a>
                      </li>
                      <li class="page-item active">
                        <span class="page-link">{{ currentPage }} / {{ totalPages }}</span>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                        <a class="page-link" @click="nextPage" href="javascript:void(0)">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Details Modal -->
  <div class="modal fade" id="detailsModal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header bg-info text-white">
          <h5 class="modal-title text-white">
            <i class="mdi mdi-information me-2"></i>
            Adjustment Details
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body" v-if="adjustmentDetails">
          <!-- Adjustment Info -->
          <div class="row mb-4">
            <div class="col-md-6">
              <h6 class="fw-bold text-primary border-bottom pb-2">Adjustment Information</h6>
              <table class="table table-sm table-borderless">
                <tr><td class="text-muted" width="40%">Reference:</td><td><strong>{{ adjustmentDetails.adjustment.adjustmentRef }}</strong></td></tr>
                <tr><td class="text-muted">Type:</td><td><span class="badge" :class="adjustmentDetails.adjustment.adjustmentType === 'Credit' ? 'bg-success' : 'bg-danger'">{{ adjustmentDetails.adjustment.adjustmentType }}</span></td></tr>
                <tr><td class="text-muted">Category:</td><td>{{ adjustmentDetails.adjustment.adjustmentCategory }}</td></tr>
                <tr><td class="text-muted">Amount:</td><td><strong>KES {{ numberFormat(adjustmentDetails.adjustment.amount) }}</strong></td></tr>
                <tr><td class="text-muted">Balance Before:</td><td>KES {{ numberFormat(adjustmentDetails.adjustment.balanceBefore) }}</td></tr>
                <tr><td class="text-muted">Balance After:</td><td>KES {{ numberFormat(adjustmentDetails.adjustment.balanceAfter) }}</td></tr>
                <tr><td class="text-muted">Status:</td><td><span class="badge" :class="getStatusBadgeClass(adjustmentDetails.adjustment.status)">{{ adjustmentDetails.adjustment.status }}</span></td></tr>
                <tr><td class="text-muted">Fiscal Year:</td><td>{{ adjustmentDetails.adjustment.fiscalYear }}</td></tr>
              </table>
            </div>
            <div class="col-md-6">
              <h6 class="fw-bold text-primary border-bottom pb-2">Plot Information</h6>
              <table class="table table-sm table-borderless">
                <tr><td class="text-muted" width="40%">Plot Number:</td><td>{{ adjustmentDetails.adjustment.plotNumber }}</td></tr>
                <tr><td class="text-muted">Zone:</td><td>{{ adjustmentDetails.adjustment.zone }}</td></tr>
                <tr><td class="text-muted">Owner:</td><td>{{ adjustmentDetails.adjustment.ownerNames }}</td></tr>
                <tr v-if="adjustmentDetails.plot"><td class="text-muted">Current Balance:</td><td><strong class="text-danger">KES {{ numberFormat(adjustmentDetails.plot.currentBalance) }}</strong></td></tr>
              </table>

              <h6 class="fw-bold text-primary border-bottom pb-2 mt-3">Request Information</h6>
              <table class="table table-sm table-borderless">
                <tr><td class="text-muted" width="40%">Requested By:</td><td>{{ adjustmentDetails.adjustment.requestedBy }}</td></tr>
                <tr><td class="text-muted">Requested Date:</td><td>{{ formatDate(adjustmentDetails.adjustment.requestedDate) }}</td></tr>
                <tr v-if="adjustmentDetails.adjustment.appliedBy"><td class="text-muted">Applied By:</td><td>{{ adjustmentDetails.adjustment.appliedBy }}</td></tr>
                <tr v-if="adjustmentDetails.adjustment.appliedDate"><td class="text-muted">Applied Date:</td><td>{{ formatDate(adjustmentDetails.adjustment.appliedDate) }}</td></tr>
              </table>
            </div>
          </div>

          <!-- Reason -->
          <div class="mb-4">
            <h6 class="fw-bold text-primary border-bottom pb-2">Reason / Justification</h6>
            <div class="bg-light p-3 rounded">{{ adjustmentDetails.adjustment.reason }}</div>
          </div>

          <!-- Supporting Documents -->
          <div class="mb-4" v-if="adjustmentDetails.adjustment.supportingDocuments">
            <h6 class="fw-bold text-primary border-bottom pb-2">Supporting Documents</h6>
            <div class="bg-light p-3 rounded">{{ adjustmentDetails.adjustment.supportingDocuments }}</div>
          </div>

          <!-- Approval Trail -->
          <div class="mb-4">
            <h6 class="fw-bold text-primary border-bottom pb-2">Approval Trail</h6>
            <div class="table-responsive">
              <table class="table table-sm table-striped">
                <thead class="table-light">
                  <tr>
                    <th>Level</th>
                    <th>Action</th>
                    <th>By</th>
                    <th>Date</th>
                    <th>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="approval in adjustmentDetails.approvals" :key="approval.id">
                    <td>Level {{ approval.approvalLevel }}</td>
                    <td>
                      <span class="badge" :class="approval.action === 'Approved' ? 'bg-success' : (approval.action === 'Rejected' ? 'bg-danger' : 'bg-warning')">
                        {{ approval.action }}
                      </span>
                    </td>
                    <td>{{ approval.approvedBy }}</td>
                    <td>{{ formatDate(approval.approvalDate) }}</td>
                    <td>{{ approval.comments || '-' }}</td>
                  </tr>
                  <tr v-if="!adjustmentDetails.approvals || adjustmentDetails.approvals.length === 0">
                    <td colspan="5" class="text-center text-muted py-3">No approval actions yet</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Activity History -->
          <div>
            <h6 class="fw-bold text-primary border-bottom pb-2">Activity History</h6>
            <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
              <table class="table table-sm">
                <thead class="table-light">
                  <tr>
                    <th>Action</th>
                    <th>Status Change</th>
                    <th>By</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="hist in adjustmentDetails.history" :key="hist.id">
                    <td><span class="badge bg-secondary">{{ hist.action }}</span></td>
                    <td>
                      <small>
                        {{ hist.previousStatus || '-' }} 
                        <i class="mdi mdi-arrow-right mx-1"></i> 
                        {{ hist.newStatus }}
                      </small>
                    </td>
                    <td>{{ hist.performedBy }}</td>
                    <td><small>{{ formatDate(hist.performedDate) }}</small></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button 
              v-if="adjustmentDetails && adjustmentDetails.adjustment.status === 'Approved' && adjustmentDetails.adjustment.isApplied == 1 && getRight('PLOTRENT REVERT ADJUSTMENT')" 
              @click="openRevertModalFromDetails" 
              class="btn btn-warning">
            <i class="mdi mdi-undo-variant me-1"></i>Revert This Adjustment
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Revert Modal -->
  <div class="modal fade" id="revertModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-warning">
          <h5 class="modal-title">
            <i class="mdi mdi-undo-variant me-2"></i>Revert Adjustment
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body" v-if="selectedAdjustment">
          <div class="alert alert-warning">
            <i class="mdi mdi-alert-outline me-2"></i>
            <strong>Warning:</strong> This will reverse the adjustment and restore the plot balance to its previous state.
          </div>

          <div class="card mb-3">
            <div class="card-body">
              <table class="table table-sm table-borderless mb-0">
                <tr><td class="text-muted">Reference:</td><td><strong>{{ selectedAdjustment.adjustmentRef }}</strong></td></tr>
                <tr><td class="text-muted">Plot:</td><td>{{ selectedAdjustment.plotNumber }} ({{ selectedAdjustment.zone }})</td></tr>
                <tr><td class="text-muted">Type:</td><td><span class="badge" :class="selectedAdjustment.adjustmentType === 'Credit' ? 'bg-success' : 'bg-danger'">{{ selectedAdjustment.adjustmentType }}</span></td></tr>
                <tr><td class="text-muted">Amount:</td><td><strong>KES {{ numberFormat(selectedAdjustment.amount) }}</strong></td></tr>
              </table>
            </div>
          </div>

          <div class="card border-info mb-3">
            <div class="card-header bg-info text-white">
              <small class="text-white">Balance Impact Preview</small>
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-4">
                  <div class="text-muted small">Current Balance</div>
                  <div class="fw-bold">KES {{ numberFormat(selectedAdjustment.balanceAfter) }}</div>
                </div>
                <div class="col-4">
                  <div class="text-muted small">Reversal</div>
                  <div class="fw-bold" :class="selectedAdjustment.adjustmentType === 'Credit' ? 'text-danger' : 'text-success'">
                    {{ selectedAdjustment.adjustmentType === 'Credit' ? '+' : '-' }} KES {{ numberFormat(selectedAdjustment.amount) }}
                  </div>
                </div>
                <div class="col-4">
                  <div class="text-muted small">New Balance</div>
                  <div class="fw-bold text-primary">KES {{ numberFormat(selectedAdjustment.balanceBefore) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Reason for Reversal <span class="text-danger">*</span></label>
            <textarea v-model="revertReason" class="form-control" rows="3" placeholder="Provide reason for reverting this adjustment..." required></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button @click="revertAdjustment" class="btn btn-warning" :disabled="isProcessing || !revertReason">
            <span v-if="isProcessing">
              <span class="spinner-border spinner-border-sm me-2"></span>Processing...
            </span>
            <span v-else>
              <i class="mdi mdi-undo-variant me-1"></i>Confirm Revert
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { execute, plotRent, getRight } from "@/api";

export default {
  name: "PlotRentAdjustmentHistory",
  components: { NavigationBar },
  data() {
    return {
      adjustments: [],
      summary: {},
      
      // Filters
      keyword: '',
      selectedStatus: '',
      selectedType: '',
      dateFrom: '',
      dateTo: '',
      
      // Pagination
      currentPage: 1,
      pageSize: 25,
      totalPages: 1,
      totalRecords: 0,
      
      // Modal data
      selectedAdjustment: null,
      adjustmentDetails: null,
      revertReason: '',
      
      // State
      loading: false,
      isProcessing: false
    }
  },
  mounted() {
    this.getAdjustments();
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    getAdjustments() {
      this.loading = true;
      this.adjustments = [];

      const data = new FormData();
      data.append("function", "getAllAdjustments");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("keyword", this.keyword);
      data.append("status", this.selectedStatus);
      data.append("adjustmentType", this.selectedType);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, plotRent)
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.adjustments = res.data.data.adjustments || [];
            this.summary = res.data.data.summary || {};
            this.totalRecords = res.data.data.count?.count || 0;
            this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
        });
    },

    viewDetails(adjustment) {
      const data = new FormData();
      data.append("function", "getAdjustmentDetails");
      data.append("adjustmentID", adjustment.id);

      execute(data, plotRent)
        .then((res) => {
          if (res.data.success) {
            this.adjustmentDetails = res.data.data;
            const modal = new bootstrap.Modal(document.getElementById('detailsModal'));
            modal.show();
          }
        })
        .catch((e) => {
          alert("Error loading details: " + e.message);
        });
    },

    openRevertModal(adjustment) {
      this.selectedAdjustment = adjustment;
      this.revertReason = '';
      const modal = new bootstrap.Modal(document.getElementById('revertModal'));
      modal.show();
    },

    openRevertModalFromDetails() {
      // Close details modal first
      const detailsModal = bootstrap.Modal.getInstance(document.getElementById('detailsModal'));
      if (detailsModal) detailsModal.hide();

      // Set selected adjustment and open revert modal
      this.selectedAdjustment = this.adjustmentDetails.adjustment;
      this.revertReason = '';
      
      setTimeout(() => {
        const modal = new bootstrap.Modal(document.getElementById('revertModal'));
        modal.show();
      }, 300);
    },

    revertAdjustment() {
      if (!this.selectedAdjustment || !this.revertReason) return;

      this.isProcessing = true;

      const data = new FormData();
      data.append("function", "revertAdjustment");
      data.append("adjustmentID", this.selectedAdjustment.id);
      data.append("reason", this.revertReason);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, plotRent)
        .then((res) => {
          this.isProcessing = false;
          
          if (res.data.success) {
            alert("Adjustment reverted successfully! The plot balance has been restored.");
            this.closeModal('revertModal');
            this.getAdjustments();
          } else {
            alert("Failed: " + res.data.message);
          }
        })
        .catch((e) => {
          this.isProcessing = false;
          alert("Error: " + e.message);
        });
    },

    closeModal(modalId) {
      const modal = bootstrap.Modal.getInstance(document.getElementById(modalId));
      if (modal) modal.hide();
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getAdjustments();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getAdjustments();
      }
    },

    exportToExcel() {
      const data = new FormData();
      data.append("function", "exportAdjustments");
      data.append("keyword", this.keyword);
      data.append("status", this.selectedStatus);
      data.append("adjustmentType", this.selectedType);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      // This would trigger Excel download
      // Implementation depends on your backend export function
      alert("Export functionality - integrate with your existing export mechanism");
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    getStatusBadgeClass(status) {
      switch (status) {
        case 'Approved': return 'bg-success';
        case 'Rejected': return 'bg-danger';
        case 'Cancelled': return 'bg-secondary';
        case 'Reverted': return 'bg-warning text-dark';
        case 'Pending': return 'bg-info';
        case 'Pending Level 2': return 'bg-info';
        case 'Pending Level 3': return 'bg-info';
        default: return 'bg-secondary';
      }
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body {
  padding: 1rem;
}
.mini-stat-icon {
  width: 40px;
  height: 40px;
}
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
}
</style>
